import classNames from 'classnames'
import React, { ComponentProps } from 'react'
import { LinkProps } from 'react-router'

const interactiveSelector = 'a, button, input, select, textarea, label, [role="button"], [data-do-not-navigate]'

const isInsideInteractiveElement = (target: HTMLElement, row: HTMLElement) => {
  const hit = target.closest(interactiveSelector)
  return hit !== null && hit !== row && row.contains(hit)
}

// A CSS stretched link (anchor ::after covering the row) would make the whole
// row the anchor, but it also swallows hover on every cell, which breaks the
// per-cell tooltips and text selection our tables depend on. Forwarding the
// click to the real link keeps those, at the cost of right-click and
// middle-click only working on the link itself.
export const LinkRow = ({ onClick, className, ...props }: ComponentProps<'tr'>) => {
  const forwardClickToLink = (event: React.MouseEvent<HTMLTableRowElement>) => {
    const row = event.currentTarget
    const link = row.querySelector<HTMLAnchorElement>('a[data-row-link]')
    const target = event.target as HTMLElement
    if (!link || link.contains(target) || isInsideInteractiveElement(target, row)) {
      onClick?.(event)
      return
    }
    event.stopPropagation()
    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        button: event.button,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        altKey: event.altKey
      })
    )
  }

  return <tr {...props} onClick={forwardClickToLink} className={classNames('cursor-pointer', className)} />
}

export const RowLink = ({ as, className, ...props }: LinkProps & { as: React.ElementType<LinkProps> }) => {
  const LinkComponent = as
  return <LinkComponent data-row-link {...props} className={classNames('text-inherit no-underline', className)} />
}
